// /benefitcategory/attachment/{countryCode}/{clientInternalNumberGos}/{benefitCategoryTag}:
import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  attachmentName: string;
  rowVersion: string;
};

const deleteAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  attachmentName,
  rowVersion,
}: Params) => {
  const response = await api.patch(
    `/benefitcategory/attachment/delete/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${attachmentName}`,
    {
      rowVersion,
    }
  );
  return response.data as Attachment;
};

export function useDeleteBenefitCategoryAttachment(refetch = true) {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(deleteAttachment, {
    mutationKey: MUTATION_KEYS.deleteBenefitCategoryAttachment,
    onSuccess: () => {
      if (refetch) {
        queryClient.refetchQueries({
          queryKey: QUERY_KEYS.benefitCategories,
        });
      }
      // queryClient.invalidateQueries({ queryKey: QUERY_KEYS.benefitCategories });
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
